<template>
    <div class="uk-width-1-2@m">
        <div class="store-locator__map-wrapper uk-panel">
            <div class="uk-inline uk-width-1-1 uk-height-large">
                <rubinred-map classes="uk-position-top-left uk-width-1-1 uk-height-1-1">
                    <rubinred-marker v-for="store in filteredList" :key="store.id" :lat="store.position.coordinates[1]" :lng="store.position.coordinates[0]"></rubinred-marker>
                </rubinred-map>
            </div>
        </div>
    </div>
</template>

<script>
    import StoreLocator from "rubinred/store-locator/js/mixins/StoreLocator";
    export default {
      mixins: [StoreLocator],
      props: {
        stores: {
          type: Array,
          required: true,
        },
      },
      created() {
        let self = this;
        //pass all stores to mixins
        self.allStores = self.stores;
        this.$root.$on('rubinred.store-locator.search', place => {
          self.queryPlace = place;
          this.$root.$emit('rubinred.map.refresh', self.filteredList.map(item => {
            return item.position;
          }));
        });
      }
    }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/store-locator/assets/js/components/StoreLocatorMap.vue